import { WordApi } from './word.api'
import { FeedbackApi } from './feedback.api'
import { UserApi } from './user.api'
import { AuthenticationApi } from './authentication.api'
import { ReportApi } from './report.api'
import { OrderApi } from './order.api'
import { DictWordApi } from './dict-word.api'
import { LookupWordApi } from './lookupWord.api'
import { DictWordMeaningApi } from './dictWordMeaning'
import { DictWordTypeApi } from './dictWordType'
import { DictWordExampleApi } from './dictWordExample'
import { StatisticApi } from './statistic.api'
import { NotificationAdminApi, NotificationApi } from './notification.api'
import { AgentsAdminApi } from './agents-admin.api'
import { ReleaseAdminApi } from './release.api'
import { EmailAdminApi } from './email.api'
import { BlogAdminApi } from './blog.api'
import { CourseCategoryAdminApi } from './courseCategory.api'
import { AnnouncementAdminApi } from './announcement.api'
import { I18nLanguageAdminApi, I18nTranslationAdminApi, I18nCourseAdminApi } from './i18n.api'
import { VoucherAdminApi } from './voucher.api'
import { ChatSeedAdminApi } from './chat-seed.api'
class api {
	static wordApi = new WordApi()
	static feedbackApi = new FeedbackApi()
	static userApi = new UserApi()
	static authentication = new AuthenticationApi()
	static reportApi = new ReportApi()
	static orderApi = new OrderApi()
	static dictWordApi = new DictWordApi()
	static lookupWordApi = new LookupWordApi()
	static dictWordTypeApi = new DictWordTypeApi()
	static dictWordMeaningApi = new DictWordMeaningApi()
	static dictWordExampleApi = new DictWordExampleApi()
	static statisticApi = new StatisticApi()
	static notificationApi = new NotificationApi()
	static notificationAdminApi = new NotificationAdminApi()
	static agentsAdminApi = new AgentsAdminApi()
	static releaseAdminApi = new ReleaseAdminApi()
	static emailAdminApi = new EmailAdminApi()
	static blogAdminApi = new BlogAdminApi()
	static courseCategoryAdminApi = new CourseCategoryAdminApi()
	static announcementAdminApi = new AnnouncementAdminApi()
	static i18nLanguageApi = new I18nLanguageAdminApi()
	static i18nTranslationApi = new I18nTranslationAdminApi()
	static i18nCourseApi = new I18nCourseAdminApi()
	static voucherAdminApi = new VoucherAdminApi()
	static chatSeedAdminApi = new ChatSeedAdminApi()
}

export default api
